import { render, staticRenderFns } from "./DadosReceitasDiversas.vue?vue&type=template&id=25375a50&scoped=true&"
import script from "./DadosReceitasDiversas.vue?vue&type=script&lang=js&"
export * from "./DadosReceitasDiversas.vue?vue&type=script&lang=js&"
import style0 from "./DadosReceitasDiversas.vue?vue&type=style&index=0&id=25375a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25375a50",
  null
  
)

export default component.exports